<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M32.5488 99.3103L36.6538 106.319C38.0495 108.703 41.1133 109.502 43.4979 108.106L103.065 73.2289C105.449 71.8332 106.248 68.7694 104.852 66.3848L100.747 59.3765C100.254 58.5369 99.2357 58.1413 98.3214 58.4734C94.2687 59.9549 89.6115 58.3727 87.3537 54.5177C85.096 50.6628 85.9954 45.8264 89.2719 43.0164C90.0108 42.382 90.1638 41.2998 89.6712 40.4601L86.3275 34.7505"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M91.8276 23.2715L95.6154 30.4552C96.0669 31.3172 95.8691 32.392 95.1041 32.9928C91.7045 35.6535 90.5924 40.4451 92.6747 44.4008C94.7608 48.3528 99.3434 50.1403 103.456 48.8379C104.381 48.5431 105.385 48.9872 105.84 49.8492L109.624 57.0329C110.916 59.4772 109.979 62.5037 107.535 63.7912L104.318 65.4779L100.743 59.3765C100.254 58.5368 99.2315 58.1412 98.3172 58.4734C94.2607 59.9549 89.6035 58.3726 87.3457 54.5177C85.088 50.659 85.9911 45.8264 89.2639 43.0126C89.999 42.3782 90.1558 41.296 89.6632 40.4563L83.1475 29.3282L26.1819 62.6828L24.1481 58.8242C22.8606 56.3836 23.7973 53.3534 26.2379 52.0696L85.0731 21.1817C87.5137 19.8942 90.5439 20.8309 91.8276 23.2715Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M88.8798 38.8777L85.3682 32.8808C84.0583 30.6417 81.1774 29.8879 78.9383 31.2015C78.9383 31.2015 22.9878 60.4922 18.1775 66.7765C13.9382 72.3145 18.2223 81.532 26.4546 80.405C35.1869 79.2108 40.4935 88.7268 31.4776 97.4816"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M95.6865 77.5503L72.8145 38.486"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="1.87 5.6" />
        <path
            d="M33.1875 67.9185C33.1875 67.9185 62.3476 50.312 67.3967 47.89"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.5254 95.8247C49.5254 95.8247 81.0627 77.1397 83.4547 75.9568"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.6777 97.7914C50.6777 97.7914 76.3636 83.0173 77.4495 82.1217"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.2526 69.4784C55.2526 69.4784 52.9389 61.8842 54.663 62.0671C56.3908 62.2499 63.3207 67.3811 62.3019 69.5567C61.2832 71.7286 54.5063 68.3924 63.164 64.5674C69.1759 61.9141 68.5751 63.5486 67.5899 66.0041C66.6047 68.4596 61.7161 84.0584 59.4882 82.9762C57.2603 81.894 59.0964 75.8821 56.0363 75.4343C52.9762 74.9865 49.0168 75.7776 49.2183 73.8557C49.3863 72.2436 52.2784 70.9375 52.2784 70.9375"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.7988 71.0532C65.7988 71.0532 71.1166 74.979 70.3105 76.5613C69.9187 77.3301 67.2803 77.2629 66.0526 77.1733"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M45.7219 82.0208L47.711 82.2709C47.961 82.3082 48.1439 82.2074 48.267 81.9611C48.3902 81.7148 48.3491 81.5096 48.1476 81.3379L46.5802 79.9198L47.4162 77.83C47.502 77.5949 47.4498 77.3972 47.252 77.233C47.0542 77.0688 46.8489 77.0538 46.6362 77.177L44.8524 78.2219L43.2478 76.7926C43.0463 76.6247 42.8373 76.6023 42.6246 76.7254C42.4119 76.8486 42.3298 77.0426 42.3783 77.3001L42.8373 79.3974L41.0274 80.4572C40.8147 80.5841 40.7326 80.7669 40.7848 81.0132C40.837 81.2595 40.9863 81.4013 41.2363 81.4424L43.4194 81.7633L43.9008 83.8494C43.9493 84.1069 44.1023 84.2487 44.3636 84.2711C44.6248 84.2935 44.8039 84.1815 44.9047 83.939L45.7182 82.0171L45.7219 82.0208Z"
            class="primary-fill" />
        <path
            d="M76.468 64.0188L78.4571 64.2688C78.7071 64.3061 78.89 64.2054 79.0131 63.9591C79.1363 63.7128 79.0952 63.5075 78.8937 63.3358L77.3263 61.9178L78.1623 59.828C78.2481 59.5929 78.1958 59.3951 77.9981 59.2309C77.8003 59.0667 77.595 59.0518 77.3823 59.1749L75.5985 60.2198L73.9939 58.7905C73.7924 58.6226 73.5834 58.6002 73.3707 58.7234C73.1579 58.8465 73.0758 59.0406 73.1244 59.2981L73.5834 61.3953L71.7735 62.4551C71.5607 62.582 71.4786 62.7649 71.5309 63.0112C71.5831 63.2575 71.7324 63.3993 71.9824 63.4403L74.1655 63.7613L74.6469 65.8473C74.6954 66.1048 74.8484 66.2466 75.1097 66.269C75.3709 66.2914 75.55 66.1795 75.6508 65.9369L76.4643 64.015L76.468 64.0188Z"
            class="primary-fill" />
    </svg>
</template>
